/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */







// CUSTOM PAGINATION START VK

function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
// if(window.location.href.includes('?page=')){
// window.location.replace(window.location.href.split('?')[0]);
// }

function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("product-list");
    if(proGrid){
      // replace grid 
      proGrid.innerHTML = document.querySelector("product-list").innerHTML + html.querySelector("product-list").innerHTML;
      // replace pagination
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); 
      let pagination = document.querySelector("page-pagination");
      let newPagination = html.querySelector("page-pagination");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
      }
      pagination_click_fun();
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}
// CUSTOM PAGINATION END VK

      function recentlyViewedslider() {
        var featured_collections = new Swiper(document.querySelector("#custom-recently-viewed-products-slider"), {
                   slidesPerView: 3,
                   spaceBetween: 10,
                   loop: false,
                   direction:'horizontal',
                   navigation:{
                   nextEl:document.querySelector("#recently-viewed-products-slider-main").querySelector('.swiper-button-next'),
                   prevEl:document.querySelector("#recently-viewed-products-slider-main").querySelector('.swiper-button-prev')
                   },
                  pagination: {
                                el: document.querySelector("#recently-viewed-products-slider-main").querySelector('.swiper-pagination'),
                                clickable: true
                                },
                   keyboard:{
                   enabled:true,
                   onlyInViewport:true
                   },
                   effect:'slide',
                   speed:500,
                   breakpoints: { 
                   275: { slidesPerView: 1, spaceBetween: 0 },
                   320: { slidesPerView: 2, spaceBetween: 10 },
                   769: { slidesPerView: 3, spaceBetween: 10 },
                   1200: { slidesPerView: 4,  spaceBetween: 16 }
                   }
       });
      }


function recommendationsslider() {
        var featured_collections = new Swiper(document.querySelector("#product-recommendations-slider"), {
                   slidesPerView: 3,
                   spaceBetween: 10,
                   loop: false,
                   direction:'horizontal',
                   navigation:{
                   nextEl:document.querySelector("product-recommendations").querySelector('.swiper-button-next'),
                   prevEl:document.querySelector("product-recommendations").querySelector('.swiper-button-prev')
                   },
                  pagination: {
                            el: document.querySelector("product-recommendations").querySelector('.swiper-pagination'),
                            clickable: true
                        },
                   keyboard:{
                   enabled:true,
                   onlyInViewport:true
                   },
                   effect:'slide',
                   speed:500,
                   breakpoints: { 
                   275: { slidesPerView: 1, spaceBetween: 0 },
                   320: { slidesPerView: 2, spaceBetween: 10 },
                   769: { slidesPerView: 3, spaceBetween: 10 },
                   1200: { slidesPerView: 4,  spaceBetween: 16 }
                   }
       });
      }




$( document ).ready(function() {

const cust_filter = document.querySelectorAll("input[name='gender']") || null;
cust_filter.forEach((input) => {
        input.addEventListener('change', (event) => {
        const name = document.querySelector('[for="'+event.target.id+'"]');
          // console.log(name);
            name.querySelector('a').click();
        });
});


$(document).on("click","[datascroll-click]",function(event) {
if($(this.hash)){
  event.preventDefault(); //prevents previous event
  smoothScroll($(this.hash));
}
});
function smoothScroll(target) {
  if(!target) return;
 if(!target.offset()) return;
    $("body,html").animate(
        {
            scrollTop: target.offset().top - $('store-header').height()
        },
        200
    );
}




  

autosize();
function autosize(){
    var text = $('.autosize');

    text.each(function(){
        $(this).attr('rows',2);
        resize($(this));
    });

    text.on('input', function(){
        resize($(this));
    });
    
    function resize ($text) {
        $text.css('height', 'auto');
        $text.css('height', $text[0].scrollHeight+'px');
    }
}

  
  gsap.registerPlugin(ScrollTrigger);

let revealContainers = document.querySelectorAll(".image-right");

revealContainers.forEach((container) => {
  let image = container.querySelector("img");
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      toggleActions: "restart none none reset"
    }
  });

  tl.set(container, { autoAlpha: 1 });
  tl.from(container, 1.5, {
    xPercent: 100,
    ease: Power2.out
  });
  tl.from(image, 1.5, {
    xPercent: -100,
    scale: 1,
    delay: -1.5,
    ease: Power2.out
  });
});

    let revealContainers_left = document.querySelectorAll(".image-left");

revealContainers_left.forEach((container) => {
  let image = container.querySelector("img");
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      toggleActions: "restart none none reset"
    }
  });

  tl.set(container, { autoAlpha: 1 });
  tl.from(container, 1.5, {
    xPercent: -100,
    ease: Power2.out
  });
  tl.from(image, 1.5, {
    xPercent: 100,
    scale: 1,
    delay: -1.5,
    ease: Power2.out
  });
});

let reveal = document.querySelectorAll(".highlight-content-text-inner , .image-with-text__content") 

reveal.forEach( (el) => {
  let headings = el.querySelectorAll("h2, h6, h3, p")
  
  let tl = gsap.timeline ()
  .from(headings, {y:80, stagger:0.05, opacity:0, duration:1, ease:"power3.out"})
  
  ScrollTrigger.create ({
		  trigger: el,
			start: "center 100%", 
      end:"top 50%",
			markers: false,
			toggleActions: "play none none reverse ",
      animation:tl
      })
})



  let tabs_title = document.querySelectorAll("product-list");
      tabs_title.forEach(featured_collections_swiper);

   function featured_collections_swiper (item) {
   var featured_collections = new Swiper(item.querySelector(".featured-swiper"), {
               slidesPerView: 3,
               spaceBetween: 10,
               loop: false,
               direction:'horizontal',
               navigation:{
               nextEl:item.querySelector('.swiper-button-next'),
               prevEl:item.querySelector('.swiper-button-prev')
               },
               keyboard:{
               enabled:true,
               onlyInViewport:true
               },
               effect:'slide',
               speed:500,
               breakpoints: { 
               275: { slidesPerView: 1, spaceBetween: 0, loop: true  },
               320: { slidesPerView: 2, spaceBetween: 10, loop: true  },
               769: { slidesPerView: 3, spaceBetween: 10, loop: true },
               1200: { slidesPerView: 4,  spaceBetween: 16 }
               }
   });
   }


  let slider = document.querySelectorAll(".swiper_slider");
      slider.forEach(swiper_slider);

   function swiper_slider (item) {
   var swiper_slider = new Swiper(item, {
               slidesPerView: 3,
               spaceBetween: 10,
               loop: false,
               direction:'horizontal',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
               keyboard:{
               enabled:true,
               onlyInViewport:true
               },
               effect:'slide',
               speed:500,
               breakpoints: { 
               275: { slidesPerView: 1.3, spaceBetween: 16, "centeredSlides": true,"loop": true },
               575: { slidesPerView: 1.3, spaceBetween: 16, "centeredSlides": true,"loop": true },
               576: { slidesPerView: 1.3, spaceBetween: 16, "centeredSlides": true,"loop": true },
               769: { slidesPerView: 3, spaceBetween: 16 },  
               1200: { slidesPerView: 4,  spaceBetween: 16 }
               }
   });
   }

  let icon_slider = document.querySelectorAll(".icon_swiper_slider");
      icon_slider.forEach(icon_swiper_slider);

   function icon_swiper_slider (item) {
   var icon_swiper_slider = new Swiper(item, {
               slidesPerView: 3,
               spaceBetween: 10,
               loop: false,
               direction:'horizontal',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
               keyboard:{
               enabled:true,
               onlyInViewport:true
               },
               effect:'slide',
               speed:500,
               breakpoints: { 
               275: { slidesPerView: 2, spaceBetween: 10 },
               400: { slidesPerView: 3, spaceBetween: 10 },
               576: { slidesPerView: 3, spaceBetween: 16 },
               769: { slidesPerView: 3, spaceBetween: 16 },  
               1000: { slidesPerView: 4,  spaceBetween: 16 },  
               1200: { slidesPerView: 5,  spaceBetween: 16 }
               }
   });
   }  

  
  let image_slider = document.querySelectorAll(".image_swiper_slider");
      image_slider.forEach(image_swiper_slider);

   function image_swiper_slider (item) {
   var image_swiper_slider = new Swiper(item, {
               slidesPerView: 3,
               spaceBetween: 10,
               centeredSlides:true,
               loop: true,
               direction:'horizontal',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
               keyboard:{
               enabled:true,
               onlyInViewport:true
               },
               effect:'slide',
               speed:500,
               breakpoints: { 
               275: { slidesPerView: 1.2, spaceBetween: 10 },
               400: { slidesPerView: 1.2, spaceBetween: 10 },
               576: { slidesPerView: 2.5, spaceBetween: 10 },
               769: { slidesPerView: 2.5, spaceBetween: 16 },  
               1000: { slidesPerView: 3.5,  spaceBetween: 16 },  
               1200: { slidesPerView: 3.5,  spaceBetween: 16 }
               }
   });
   } 

  let menu_slider = document.querySelectorAll(".menu_swiper_slider");
      menu_slider.forEach(menu_swiper_slider);

   function menu_swiper_slider (item) {
   var menu_swiper_slider = new Swiper(item, {
               slidesPerView: 3,
               spaceBetween: 10,
               loop: false,
               direction:'horizontal',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
               keyboard:{
               enabled:true,
               onlyInViewport:true
               },
               effect:'slide',
               speed:500,
               breakpoints: { 
               275: { slidesPerView: 1.5, spaceBetween: 10 },
               400: { slidesPerView: 2.5, spaceBetween: 10 },
               576: { slidesPerView: 2.5, spaceBetween: 10 },
               769: { slidesPerView: 3, spaceBetween: 16 },  
               1000: { slidesPerView: 4,  spaceBetween: 16 },  
               1200: { slidesPerView: 4,  spaceBetween: 16 }
               }
   });
                         if(item.querySelector('.link--faded.active').getAttribute('data-slider-id') != null){
                           menu_swiper_slider.slideTo(item.querySelector('.link--faded.active').getAttribute('data-slider-id'),1000,false);
                         }
   } 

 

  let cor_image_slider = document.querySelectorAll(".cor_image_swiper_slider");
      cor_image_slider.forEach(cor_image_swiper_slider);

   function cor_image_swiper_slider (item) {
   var cor_image_swiper_slider = new Swiper(item, {
               slidesPerView: 3,
               spaceBetween: 10,
               loop: false,
               direction:'horizontal',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
               keyboard:{
               enabled:true,
               onlyInViewport:true
               },
               effect:'slide',
               speed:500,
               breakpoints: { 
               275: { slidesPerView: 1.2, spaceBetween: 10, "centeredSlides": true,"loop": true  },
               400: { slidesPerView: 1.2, spaceBetween: 10, "centeredSlides": true,"loop": true  },
               576: { slidesPerView: 1.2, spaceBetween: 10, "centeredSlides": true,"loop": true  },
               741: { slidesPerView: 3, spaceBetween: 20 },  
               1000: { slidesPerView: 3,  spaceBetween: 20 },  
               1200: { slidesPerView: 3,  spaceBetween: 20 }
               }
   });
   } 
  
});


if (matchMedia) {
  const mq = window.matchMedia("(min-width: 741px)");
  mq.addListener(WidthChange);
  WidthChange(mq);
}

// media query change
function WidthChange(mq) {
  if(!mq.matches){
            function tab_toggle(item){
               item.setAttribute('role', 'button');
               item.addEventListener("click", () => {
                              if(item.classList.contains('is_open')){
                                 item.classList.remove("is_open");
                              }else{
                                let tabs_button = document.querySelectorAll("[data-accodian-tragger]");
                                  tabs_button.forEach(b => {
                                         b.classList.remove("is_open"); 
                                    });
                                  item.classList.add("is_open");
                              }
                }); 
            } 
     let tabs_acc  = document.querySelectorAll("[data-accodian-tragger]");
      tabs_acc.forEach(tab_toggle);
  }
  
}


let swiper = new Swiper(".image-with-text__image-wrapper.mySwiper", {
  slidesPerView: "auto",
  spaceBetween: 30,
  autoHeight: true,
  pagination: {
    el: ".homeimage_dots",
      clickable: true,
  },
    autoplay: {
   delay: 3000,
   disableOnInteraction: false,
 },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});




// product personlize

const custom_checkbox = document.querySelector('[custom_checkbox]') || null;
if (custom_checkbox) {
  custom_checkbox.addEventListener('change', function() {
      if (custom_checkbox.checked) {
        // console.log("checked");
        document.querySelectorAll('[add_hide]').forEach(item => {
          item.removeAttribute('hidden');
          // console.log("data",item.classList)
          
          if (item.classList.contains('color_main')) {
            document.querySelectorAll('[inp_color]').forEach(b => {
              b.querySelector('input').addEventListener('change', function() {
                const selectedColor = b.querySelector('input:checked').value;
                console.log("Selected color:", selectedColor);
                document.querySelector('input[p_custom_color]').value = selectedColor;
              });
            });
          } else if (item.classList.contains('text_main')) {
              var inputElement = document.querySelector('[inpuT_text]');
              inputElement.addEventListener('input', function(event) {
                var inputValue = event.target.value;
                console.log("inputValue",inputValue)
                document.querySelector('input[p_custom_text').value = inputValue;
              });
          } else if (item.classList.contains('shoe_main')){

            document.querySelectorAll('[btn_re]').forEach(b => {
              
              var input_btn = b.querySelector('input');
              input_btn.addEventListener('change', function() {
                const selectedShoe = b.querySelector('input:checked').value;
                console.log("Selected color:", selectedShoe);                
                document.querySelector('input[p_custom_shoe]').value = selectedShoe;
              });
            });
            
          } else if (item.classList.contains('side_main')) {
            //p_custom_side

            document.querySelectorAll('[side_btn_re]').forEach(b => {
              var input_btn_ = b.querySelector('input');
              input_btn_.addEventListener('change', function() {
                const selectedSide = b.querySelector('input:checked').value;
                console.log("Selected color:", selectedSide);
                document.querySelector('input[p_custom_side]').value = selectedSide;
              });
            });
            
          }
        });
      }else{
        document.querySelectorAll('[add_hide]').forEach(item => {
          item.setAttribute('hidden', '');
          document.querySelector('input[p_custom_color]').value = '';
          document.querySelector('input[p_custom_text').value = '';
          document.querySelector('input[p_custom_shoe]').value = '';
          document.querySelector('input[p_custom_side]').value = '';
          document.querySelector('[inpuT_text]').value = '';
        });
      }
  });
}

